import React from 'react';
import getConfig from 'next/config';
import PropTypes from 'prop-types';
import { getAudioFileUrl } from '@culture/utils/helpers/files';

import { AudioPlayer } from 'components/Audio/AudioPlayer';

import styles from '../styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const Audio = (props) => {
	const trackUrl = getAudioFileUrl(props?.material?.files[0], {
		config: publicRuntimeConfig
	});

	return <AudioPlayer trackSrc={trackUrl} className={styles.audio} />;
};

Audio.propTypes = {
	material: PropTypes.exact({
		files: PropTypes.arrayOf(PropTypes.object)
	})
};

export default Audio;
